import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { callService, goTo } from "./../tools";

import { nombreProductoGM, getNumPoliza } from "../common/logica";
import { getFechasVigencia } from "./logicaFechas";

const mapState = (state) => {
	return {
		"polizasCargadas": state.polizas.polizasCargadas,
		"pagoPorKM": state.polizas.pagoPorKilometro,
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		setPago: (oPoliza) => {
			dispatch({ "type": "SET_DETALLE_POLIZA", "poliza": oPoliza });
			dispatch({ "type": "SET_POLIZA_SELECCIONADA", "polizaSeleccionada": oPoliza.generales.numPoliza });
			dispatch({ "type": "SET_RAMO_ACTUAL", "ramoActual": oPoliza.generales.cveRamo });
		}
	};
};

class CardPoliza extends React.Component {

	constructor(props) {
		super(props);
		this.state = { isLoading: true, esDBK: true };
	}
	
	componentDidMount() {
		let poliza = this.props.item.generales;
		if(poliza.cveRamo == "A"){
			let llamaServicio = new callService({
				service: "pagoPorKilometro.restriccionDBK",
				secure: true,
				data: { "poliza": poliza.numPoliza }
			}).execute().then((respuesta) => {
				let paquete = respuesta.paquete;
				paquete = paquete.toLowerCase();
				if (paquete == "limitada" || paquete.includes("responsabilidad civil") ){
					this.setState({ esDBK: false });		
				}
				this.setState({ isLoading: false });
			}).catch((error) => {
				this.setState({ isLoading: false });
			});
		} else {
			this.setState({ isLoading: false });
		}
	}

	
	pago = (item, event) => {
		event.stopPropagation();
		console.log(event.currentTarget);
		console.log(item);
		this.props.setPago(item);
		goTo("detalle/" + item.generales.numPoliza);
	}
	
	viaNomina = ( item, event) => {
		event.preventDefault();
		event.stopPropagation();
		this.props.onViaNomina(item);
	}

	textoEsquina = oItem => {
		let texto = "";
		
		switch(oItem.generales.cveRamo) {
		case "A":
			texto = oItem.vehiculo.placas;
			break;
		case "V":
			if (oItem.generales.cveProdComercial == "00001" && oItem.generales.cveProdTecnico == "V1011FONDO" ) {
				texto = oItem.generales.estatusCapitaliza;
			}	
		}
		
		return texto;
	}

	policyStartDateIsFuture = (date) => {

		let currentDate = moment().format('DD/MM/YYYY');		
		let fechaFutura = moment(date, 'DD/MM/YYYY').add(14, 'd').format('DD/MM/YYYY');

		return (moment(fechaFutura, 'DD/MM/YYYY').diff(moment(currentDate, 'DD/MM/YYYY'),'d') <= 14) ? false : true;
	}

	
	render() {
		const { isLoading, esDBK } = this.state;
		let item = this.props.item;
		let estatus = "";
		let fechas = getFechasVigencia(item);

		if (isLoading) {
			return <div className="col-md-4 col-xs-12">
						<div className="card select-card">
							<img  style={{"display":"block", "margin-right":"auto", "margin-left":"auto"}} src={ require("../img/load_mini.gif") } />
						</div>
					</div>;
		  }

		if (this.props.polizasCargadas) {
			estatus = item.generales.viaNomina ? 'Renovación vía nómina':item.generales.estatus;
		}

		return <div className="col-md-4 col-xs-12">
			<div className="card select-card" onClick={this.props.setDetalle.bind(this, [item, item.generales.cveRamo,estatus])} >
				{ item.generales.cveRamo == "A" &&
				<div className="clearfix">
					<div className="pull-left poliza-head">
						<h6>{ ( item.generales.cveClasificacionSeguro == "06" || item.generales.cveClasificacionSeguro == "05") ? ("GRUPO: ") : ""}{item.vehiculo.descripcion}</h6>
					</div>
					<div className="pull-right matricula" style={{ "marginTop": "-10px" }}>
						<h6 style={{"textAlign":"right", "fontWeight":"normal"}}>{ this.textoEsquina(item) }</h6>
					</div>
				</div>
				}
				{ item.generales.cveRamo == "G" &&
				<div className="clearfix">
					<div className="pull-left poliza-head">
						<h6>
							{ nombreProductoGM(item) }
						</h6>
					</div>
				</div>
				}
				{ item.generales.cveRamo == "V" &&
				<div className="clearfix">
					<div className="pull-left poliza-head">
						<h6>{ ( item.generales.cveClasificacionSeguro == "06" || item.generales.cveClasificacionSeguro == "05") ? ("GRUPO: ") : ""}{ item.generales.productoComercial }</h6>
					</div>
					<div className="pull-right matricula" style={{ "marginTop": "-10px" }}>
						<h6 style={{"textAlign":"right", "fontWeight":"normal"}}>{ this.textoEsquina(item) }</h6>
					</div>
				</div>
				}
				{ item.generales.cveRamo == "D" &&
				<div className="clearfix">
					<div className="pull-left poliza-head">
						<h6>{ ( item.generales.cveClasificacionSeguro == "06" || item.generales.cveClasificacionSeguro == "05") ? ("GRUPO: ") : ""}{ item.generales.productoComercial } C.P. { item.generales.codigoPostal }</h6>
					</div>
				</div>
				}
				<div className="vigencia">
					<p><b>Vigencia</b></p>
					<p><span className="blue-circle"></span>Desde el { fechas.inicioLargo }</p>
					<p><span className="orange-point"></span>Hasta el { fechas.finLargo }</p>
				</div>
				<div className="clearfix no-poliza">
					<div className="pull-left n-poliza">
						<p><img src={require("../img/icon_poliza.png")} alt=""/><b>No. Póliza: {getNumPoliza(item)}</b></p>						
						{
							esDBK &&
							this.props.pagoPorKM && 
							this.props.pagoPorKM[item.generales.numPoliza] && 
							this.props.pagoPorKM[item.generales.numPoliza].candidate &&
							!this.props.pagoPorKM[item.generales.numPoliza].enabled && 
							!this.props.pagoPorKM[item.generales.numPoliza].isStartKmCaptured
							&& (item.generales.claveRol == 'TOM' || item.generales.claveRol == 'COH')
							&& this.policyStartDateIsFuture(item.generales.fchVigenciaInicial)
							?
							<div className="col-xs-2 pull-right tool-tip" style={{paddingLeft:"0px", paddingRight:"0px"}}>
								<a href="#" data-tooltip="Obtén hasta un 30% de bonificación en la renovación de tu Seguro. Descarga la App Soy Cliente GNP y regístrate.">
									<img 
									className="img-responsive center-block " 
									style={{'marginTop': '-70px','marginBottom':'0px'}}
									src={require('../img/smart-trip-bk.png')} />
								</a>
							</div>							
							:
							((
							esDBK &&
							this.props.pagoPorKM &&
							this.props.pagoPorKM[item.generales.numPoliza] &&
							this.props.pagoPorKM[item.generales.numPoliza].isStartKmCaptured) 
							|| 
							(
							esDBK &&
							this.props.pagoPorKM && 
							this.props.pagoPorKM[item.generales.numPoliza] && 
							this.props.pagoPorKM[item.generales.numPoliza].candidate && 
							this.props.pagoPorKM[item.generales.numPoliza].enabled && 
							(item.generales.claveRol == 'TOM' || item.generales.claveRol == 'COH') && 
							!this.policyStartDateIsFuture(item.generales.fchVigenciaInicial) ) )&&
							<div className="col-xs-2 pull-right tool-tip" style={{paddingLeft:"0px", paddingRight:"0px"}}>
								<a href="#" data-tooltip="Obtén hasta un 30% de bonificación en la renovación de tu Seguro. Descarga la Aplicación Soy Cliente GNP y regístrate."  >
									<img 
									className="img-responsive center-block" 
									style={{'marginTop': '-70px','marginBottom':'0px'}} 
									src={require('../img/smart-trip.png')} />
                                </a>
							</div>
						}

					</div>
					<div className="pull-right estado-poliza">
						{ this.props.polizasCargadas && !item.generales.viaNomina &&
							item.generales.detalle != "capitaliza" && 
							item.generales.detalle != "inversion" &&
							!(item.generales.cveProdComercial == "00012" && item.generales.cveProdTecnico == "A2400FLOT") && // AUTO MAS
							!(item.generales.cveProdComercial == "00002" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS
							!(item.generales.cveProdComercial == "00003" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS INCREMENTO
                            <p className="orange-text pago-pendiente">{ estatus }</p>
						}
						{ this.props.polizasCargadas && !item.generales.viaNomina&&
							(item.generales.detalle == "capitaliza" || item.generales.detalle == "inversion") && 
							estatus != "" &&
							!(item.generales.cveProdComercial == "00012" && item.generales.cveProdTecnico == "A2400FLOT") && // AUTO MAS
							!(item.generales.cveProdComercial == "00002" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS
							!(item.generales.cveProdComercial == "00003" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS INCREMENTO
                            <p onClick={this.pago.bind(this, item)} className="pago-pendiente capitaliza">{ estatus }</p>
						}
						{ this.props.polizasCargadas && 
							item.generales.viaNomina &&
							item.generales.detalle !== "capitaliza" && 
							item.generales.detalle !== "inversion" &&
							!(item.generales.cveProdComercial === "00012" && item.generales.cveProdTecnico === "A2400FLOT") && // AUTO MAS
							!(item.generales.cveProdComercial === "00002" && item.generales.cveProdTecnico === "V1011PFLVM") && // VIDA MAS
							!(item.generales.cveProdComercial === "00003" && item.generales.cveProdTecnico === "V1011PFLVM") && // VIDA MAS INCREMENTO
                            <p onClick={this.viaNomina.bind(this, item)} className="blue-text">{ estatus }</p>
						}
					</div>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(CardPoliza);



// WEBPACK FOOTER //
// ./src/home/cardPoliza.cmpt.js